import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { EffectApiClientContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import {
  ReloadUserContext,
  UserContext,
} from "@redotech/redo-merchant-app-common/user";
import { useState } from "react";
import { catchApiErrors } from "../db/error-handling";

export interface SupportV2UserOrderingItem {
  id: string;
  type: "view" | "folder";
}

export function useSupportV2UserOrdering(): {
  ordering: SupportV2UserOrderingItem[];
  saveOrdering: (items: SupportV2UserOrderingItem[]) => Promise<void>;
} {
  const user = useRequiredContext(UserContext);
  const effectApi = useRequiredContext(EffectApiClientContext);
  const reloadUser = useRequiredContext(ReloadUserContext);

  const [localOrdering, setLocalOrdering] = useState<
    SupportV2UserOrderingItem[] | undefined
  >(undefined);

  const ordering: SupportV2UserOrderingItem[] =
    localOrdering ?? user.supportV2ViewOrdering ?? [];

  const saveOrdering = useHandler(
    async (items: SupportV2UserOrderingItem[]) => {
      const previous = localOrdering ?? user.supportV2ViewOrdering ?? [];
      setLocalOrdering(items);
      try {
        const client = effectApi.getClient();
        await effectApi.runPromise(
          catchApiErrors(
            client.viewFolder.saveUserViewFolderOrder({ payload: { items } }),
          ),
        );
        void reloadUser();
      } catch {
        setLocalOrdering(previous);
      }
    },
  );

  return { ordering, saveOrdering };
}
